export default __webpack_public_path__ + "static/media/mangodb.ea775467.png";